import { Box, BoxProps } from '@mui/material';
import React from 'react';

type Props = BoxProps & {};

const FlexBox: React.FC<Props> = ({ children, sx, display = 'flex', flexDirection = 'column', gap = 4, ...props }) => {
  return (
    <Box
      sx={{
        display,
        flexDirection,
        gap,
        ...sx,
      }}
      {...props}>
      {children}
    </Box>
  );
};

export default React.memo(FlexBox);
